export const RaikoUploadFileTypes = {
    APK: "APK",
    MUSIC: "MUSIC",
    IMAGE: "IMAGE",
    VIDEO: "VIDEO",
    DOCUMENT: "DOCUMENT",
}